module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.6807/img/storefront-header-blobs.svg"